import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowPathDown"><Path d="M16 2.5H9V13.5H5L12.5 22.25L20 13.5H16V2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowPathDown;
